module.exports = __webpack_public_path__ + "static/img/nav18.42b77af6.svg";